import {
  CreateScheduledQueryBody,
  ListScheduledQueriesParams,
  ScheduledQuery,
  scheduledQueriesV2,
  scheduledQueriesV3,
  scheduledQueryConversations,
  UpdateScheduledQueryBody,
} from '@api/api/scheduled-queries';
import { generatePath } from '@helpers/utils/paths/paths';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const getRoutes = () =>
  useFlags.getState().getFeatureFlagState('REASON-2703-scheduled-tasks-update')
    ? scheduledQueriesV3
    : scheduledQueriesV2;

export const listScheduledQueries = (
  params: ListScheduledQueriesParams = {}
) => {
  const path = generatePath({
    basePath: getRoutes().list.path,
    params: {
      ...(params.status && { status: params.status }),
      ...(params.page && { page: params.page }),
      ...(params.page_size && { page_size: params.page_size }),
    },
  });

  return wretchRequest(path, { schema: getRoutes().list.schema });
};

export const getScheduledQuery = (id: string) =>
  wretchRequest(getRoutes().get.path(id), {
    schema: getRoutes().get.schema,
  });

export const listScheduledQueryConversations = (
  id: string,
  params: { page?: number; page_size?: number } = {}
) => {
  // Endpoint #9 lives in conversation service, not conversation-scheduler
  const path = generatePath({
    basePath: scheduledQueryConversations.list.path(id),
    params: {
      ...(params.page && { page: params.page }),
      ...(params.page_size && { page_size: params.page_size }),
    },
  });

  return wretchRequest(path, {
    schema: scheduledQueryConversations.list.schema,
  });
};

export const createScheduledQuery = (
  body: CreateScheduledQueryBody
): Promise<ScheduledQuery> =>
  wretchRequest(getRoutes().create.path, {
    method: 'post',
    body,
    schema: getRoutes().create.schema,
  });

export const updateScheduledQuery = (
  id: string,
  body: UpdateScheduledQueryBody
) =>
  wretchRequest(getRoutes().update.path(id), {
    method: 'put',
    body,
  });

export const deleteScheduledQuery = (id: string) =>
  wretchRequest(getRoutes().delete.path(id), {
    method: 'delete',
  });

export const suspendScheduledQuery = (id: string) =>
  wretchRequest(getRoutes().suspend.path(id), {
    method: 'post',
    body: {},
  });

export const resumeScheduledQuery = (id: string) =>
  wretchRequest(getRoutes().resume.path(id), {
    method: 'post',
    body: {},
  });

export const runScheduledQueryNow = (id: string) =>
  wretchRequest(getRoutes().runNow.path(id), {
    method: 'post',
    body: {},
    schema: getRoutes().runNow.schema,
  });
